import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import openBase64NewTab from "../../utils/PdfCreator/PdfCreator";
import blackPdfIcon from "../../assets/images/pdf-black-icon.png";
import "./BlackPdfButton.scss";
import { downloadAdaMemberDocument } from "../../services/ADAService";

const BlackPdfButton = (props: { PId?: number; }) => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    // Receives doc-uri, converts to 64BIT and opens pdf in a new tab
    setLoading(true);
    if (props.PId) {
      const pdfData = await downloadAdaMemberDocument(sessionStorage.token.toUpperCase(),props.PId ,true );
      pdfData.fileContent && openBase64NewTab(pdfData.fileContent,pdfData.fileName.split(".")[1] == "DOCX");
      setLoading(false);
    }
  };


  return (

      <button
        className="black-pdf-btn"
        onClick={handleClick}
        disabled={loading}
      >
        <img src={blackPdfIcon} alt="bPdf" />
        <span className="black-pdf-text">
          {loading ? t("general.loading") : t("general.attached")}
        </span>
      </button>

  );
};

export default BlackPdfButton;
